export const CLASSIC = 'CLASSIC';
export const PLATFORM = 'PLATFORM';